import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";

import ResultsPage from "./ResultsPage";

export default function SharedReportPage() {
  const { token } = useParams();
  const [banId, setBanId] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    fetch(`/api/shares/${encodeURIComponent(token || "")}`, { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) throw new Error("Ce partage est invalide ou a été révoqué.");
        return response.json();
      })
      .then((payload) => setBanId(payload.ban_id))
      .catch((reason) => { if (reason.name !== "AbortError") setError(reason.message); });
    return () => controller.abort();
  }, [token]);
  if (banId) return <ResultsPage banIdOverride={banId} forceNoIndex />;
  return <main style={{ maxWidth: 700, margin: "80px auto", padding: 24, fontFamily: "system-ui" }}>
    <Helmet><title>Rapport partagé — État du Lieu</title><meta name="robots" content="noindex,nofollow" /></Helmet>
    <h1>{error ? "Lien indisponible" : "Ouverture du rapport…"}</h1>
    {error && <><p>{error}</p><Link to="/">Rechercher une adresse</Link></>}
  </main>;
}

